import { DiscountType, IBusinessProductData } from '@stores/products/types';

export const discountTypes: DiscountType[] = ['fixed', 'percent'];
export const MIN_VALUE = 0.01;
export const approveRequiredFields: (keyof IBusinessProductData)[] = [
  'description',
  'imageUrl',
  'name',
  'categories',
];
